
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/wisdom/topics",
      function () {
        return require("private-next-pages/[region]/wisdom/topics/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/wisdom/topics"])
      });
    }
  